import { BASE_API_URL } from '../consts/base-url';
import type { Task } from '../types/task';
import customFetch from './fetch';
export const getTaskById = async (taskId: number) => {
  const response = await customFetch(`${BASE_API_URL}/tasks/${taskId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const {
    task,
    error
  } = (await response.json() as {
    task: Task;
    error: string | undefined;
  });
  if (!task) {
    throw new Error(error);
  }
  return task;
};